import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Container, Input, Label, Row, Button, Form, FormFeedback, Alert, Spinner } from 'reactstrap';
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
// @ts-ignore
import Cookies from 'js-cookie';
//redux
import { useSelector, useDispatch } from "react-redux";

import { Link, useNavigate } from "react-router-dom";
import withRouter from "../../Components/Common/withRouter";
// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

// actions
import { resetLoginFlag } from "../../slices/thunks";


import { createSelector } from 'reselect';
import { logoutUserSuccess, AuthError, loginSuccess } from '../../slices/auth/login/reducer';
import { useAuth } from '../../Provider/AuthProvider';
import axios from 'axios';
import { getDefaultRoute } from '../Caisse/defaultRoute';

const Login = (props: any) => {
    const dispatch: any = useDispatch();

    const selectLayoutState = (state: any) => state;
    const loginpageData = createSelector(
        selectLayoutState,
        (state) => ({
            user: state.Login.user,
            error: state.Login.error,
            errorMsg: state.Login.errorMsg,
        })
    );

    const { user, error, errorMsg } = useSelector(loginpageData);
    const { login, changeOrder, setAllowedInterfaces } = useAuth();
    const navigate = useNavigate();

    const [userLogin, setUserLogin] = useState<any>([]);
    const [passwordShow, setPasswordShow] = useState<boolean>(false);
    const [loader, setLoader] = useState<boolean>(false);


    const signIn = async (inputs: any) => {
        try {
            const data = {
                action: "auth",
                user: inputs.email,
                pass: inputs.password,
            };

            const config = {
                method: 'post',
                maxBodyLength: Infinity,
                baseURL: `https://api.apapiecesauto.fr`,
                url: '/apiV2/',
                headers: { 'Content-Type': 'text/plain' },
                data: data
            };

            await axios.request(config).then(async (response: any) => {
                debugger;
                console.log("Login response:", response);
                // Check if login failed
                if (!response.userinfo) {
                    dispatch(AuthError("Email ou mot de passe invalide. Veuillez réessayer"));
                    return;
                }

                // Login successful
                login(response);

                // Get raw allowed interfaces from cookie
                const allowedInterfacesRaw = JSON.parse(Cookies.get('allowedInterfaces') || '[]');

                // Filter based on user permissions
                const allowedInterfaces = allowedInterfacesRaw.filter((item: string) => {
                    if (item === 'caisse') return response.perms?.facture?.paiement != null;
                    if (item === 'stock') return response.perms?.stock?.mouvement?.creer != null;
                    if (item === 'vendeur') return response.perms?.commande?.creer != null;
                    if (item === 'commandes') return response.perms?.commande?.creer != null;
                    if (item === 'pickups') return response.perms?.fournisseur?.commande?.receptionner != null && response.perms?.expedition?.delivery == null;
                    return true;
                });

                if (response.perms?.fournisseur?.commande?.receptionner != null
                    && response.perms?.expedition?.delivery == null
                    && !allowedInterfaces.includes('pickups')) {
                    allowedInterfaces.push('pickups');
                }
                // Update allowed interfaces in context
                setAllowedInterfaces(allowedInterfaces);

                // Save final login to redux
                const finalLogin = JSON.parse(JSON.stringify(response));
                dispatch(loginSuccess(finalLogin));

                // Fetch new commandes if any
                try {
                    const commandesResponse = await axios.post(
                        "/apiV2/",
                        { action: "topay", entity: finalLogin.entity },
                        {
                            baseURL: "https://api.apapiecesauto.fr",
                            headers: {
                                "Content-Type": "application/json",
                                "Authorization": `Bearer ${finalLogin.token}`,
                            },
                        }
                    );

                    const newCommandes = commandesResponse.data || [];
                    if (newCommandes.length > 0) {
                        const newestCommande = newCommandes[newCommandes.length - 1];
                        changeOrder(newestCommande); 
                    }
                } catch (err) {
                    console.error("Error fetching commandes after login:", err);
                }
                
                if (allowedInterfaces.length > 0) {
                    const defaultRoute = getDefaultRoute(allowedInterfaces);
                    navigate(defaultRoute);
                }
                
            }).catch(error => {
                dispatch(AuthError("Email ou mot de passe invalide. Veuillez réessayer"));
            });

        } catch (error: any) {
            dispatch(AuthError("Erreur de connexion"));
        }
    };


    const validation: any = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: userLogin.email || "" || '',
            password: userLogin.password || "" || '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Entrez votre login"),
            password: Yup.string().required("Entrez votre mot de passe"),
        }),
        onSubmit: (values) => {
            dispatch(signIn(values));

            setLoader(true)
        }
    });


    useEffect(() => {
        dispatch(logoutUserSuccess(true));
        if (errorMsg) {
            setTimeout(() => {
                dispatch(resetLoginFlag());
                setLoader(false)
            }, 3000);
        }
    }, [dispatch, errorMsg]);


    document.title = "APA";

    return (
        <React.Fragment>
            <ParticlesAuth>
                <div className="auth-page-content mt-lg-5">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 mb-4 text-white-50">
                                    <div>
                                        <Link to="/" className="d-inline-block auth-logo">
                                            <img src={""} alt="" height="60" />
                                        </Link>
                                    </div>
                                    <p className="mt-3 fs-15 fw-medium"></p>
                                </div>
                            </Col>
                        </Row>

                        <Row className="justify-content-center">
                            <Col md={8} lg={6} xl={5}>
                                <Card className="mt-4">
                                    <CardBody className="p-4">
                                        <div className="text-center mt-2">
                                            <h5 className="text-primary">Bienvenue !</h5>
                                            <img src="https://sud.apapiecesauto.fr/apaLogo.png" style={{ maxHeight: "90px" }}
                                                alt="Logo APA Pièces Auto"></img>
                                                <p className="text-muted">Interface Magasin</p>
                                        </div>
                                        {error && <Alert color="danger">{error}</Alert>}
                                        <div className="p-2 mt-4">
                                            <Form
                                                onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}
                                                action="#">

                                                <div className="mb-3">
                                                    <Label htmlFor="email" className="form-label">Login</Label>
                                                    <Input
                                                        name="email"
                                                        className="form-control"
                                                        placeholder="login"
                                                        type="text"
                                                        onChange={validation.handleChange}
                                                        onBlur={validation.handleBlur}
                                                        value={validation.values.email || ""}
                                                        invalid={
                                                            validation.touched.email && validation.errors.email ? true : false
                                                        }
                                                    />
                                                    {validation.touched.email && validation.errors.email ? (
                                                        <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                                    ) : null}
                                                </div>

                                                <div className="mb-3">
                                                    <div className="float-end">
                                                        <Link to="/forgot-password" className="text-muted">Mot de passe oublié ?
                                                        </Link>
                                                    </div>
                                                    <Label className="form-label" htmlFor="password-input">Mot de passe</Label>
                                                    <div className="position-relative auth-pass-inputgroup mb-3">
                                                        <Input
                                                            name="password"
                                                            value={validation.values.password || ""}
                                                            type={passwordShow ? "text" : "password"}
                                                            className="form-control pe-5"
                                                            placeholder="Enter Password"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            invalid={
                                                                validation.touched.password && validation.errors.password ? true : false
                                                            }
                                                        />
                                                        {validation.touched.password && validation.errors.password ? (
                                                            <FormFeedback type="invalid">{validation.errors.password}</FormFeedback>
                                                        ) : null}
                                                        <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></button>
                                                    </div>
                                                </div>

                                                {/*
                                                <div className="form-check">
                                                    <Input className="form-check-input" type="checkbox" value="" id="auth-remember-check" />
                                                    <Label className="form-check-label" htmlFor="auth-remember-check">Remember me</Label>
                                                </div>
                                                */}
                                                <div className="mt-4">
                                                    <Button
                                                        color="dark"
                                                        disabled={loader}
                                                        className="w-100"
                                                        type="submit"
                                                    >
                                                        {loader && <Spinner size="sm" className="me-2" />}
                                                        Connexion
                                                    </Button>

                                                </div>


                                            </Form>
                                        </div>
                                    </CardBody>
                                </Card>



                            </Col>
                        </Row>
                    </Container>
                </div>
            </ParticlesAuth>
        </React.Fragment>
    );
};

export default withRouter(Login);